import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreTypeSpan',
    props: {
        type: null
    },
    setup(__props) {
        const props = __props;
        const MESSAGES = {
            aws_s3: "This is an object store based on the Amazon Simple Storage Service (S3). Data here is hosted by Amazon.",
            azure_blob: "This is a Microsoft Azure Blob based object store. More information on Microsoft's Azure Blob Storage can be found at https://azure.microsoft.com/en-us/products/storage/blobs/.",
            disk: "This is a simple path based object store that assumes the all the relevant paths are already mounted on the Galaxy server and target worker nodes.",
            boto3: "This is an object store based on the Amazon Simple Storage Service (S3) interface, but likely not stored by Amazon. The AWS interface has become an industry standard and many storage vendors support it and use it to expose object based storage.",
            generic_s3: "This is an object store based on the Amazon Simple Storage Service (S3) interface, but likely not stored by Amazon. The AWS interface has become an industry standard and many storage vendors support it and use it to expose object based storage.",
        };
        const title = computed(() => { var _a; return (_a = MESSAGES[props.type]) !== null && _a !== void 0 ? _a : ""; });
        return { __sfc: true, MESSAGES, props, title };
    }
});
